export const PERMISSIONS = {
  CAN_VIEW_ACCOUNT: 'can_view_account',
  CAN_CREATE_ACCOUNT: 'can_create_account',
  CAN_UPDATE_ACCOUNT: 'can_update_account',

  CAN_VIEW_USER: 'can_view_user',
  CAN_DELETE_USER: 'can_delete_user',
  CAN_ACTIVATE_USER: 'can_activate_user',
  CAN_DEACTIVATE_USER: 'can_deactivate_user',
  CAN_UPDATE_USER: 'can_update_user',

  CAN_INVITE_USER: 'can_invite_user',
  CAN_VIEW_INVITATIONS: 'can_view_invitation',
  CAN_DELETE_INVITATION: 'can_delete_invitation',

  CAN_VIEW_PRODUCT: 'can_view_product',
  CAN_UPDATE_PRODUCT: 'can_update_product',

  CAN_UPDATE_BUSINESS: 'can_update_business',

  CAN_VIEW_LISTING: 'can_view_campaign',
  CAN_CREATE_LISTING: 'can_create_campaign',
  CAN_UPDATE_LISTING: 'can_update_campaign',
  CAN_PAUSE_LISTING: 'can_pause_campaign',
  CAN_RESUME_LISTING: 'can_resume_campaign',

  CAN_VIEW_LISTING_LINKS: 'can_view_campaign_links',
  CAN_CREATE_LISTING_LINKS: 'can_create_campaign_links',
  CAN_UPDATE_LISTING_LINKS: 'can_update_campaign_links',
  CAN_DELETE_LISTING_LINKS: 'can_delete_campaign_links',

  CAN_VIEW_LISTING_BRAND_STYLES: 'can_view_campaign_account_style_templates',
  CAN_UPDATE_LISTING_BRAND_STYLES: 'can_update_campaign_style',

  CAN_VIEW_LISTING_ANALYTICS: 'can_view_campaign_statistics',
  CAN_EXPORT_LISTING_ANALYTICS: 'can_export_campaign_export',

  CAN_VIEW_DTC_ACCOUNT: 'can_view_dtc_accounts',
  CAN_UPDATE_DTC_ACCOUNT: 'can_update_dtc_accounts',

  CAN_VIEW_DTC_PRODUCTS: 'can_view_dtc_product',
  CAN_UPDATE_DTC_PRODUCT: 'can_update_dtc_product',
  CAN_SYNC_DTC_PRODUCTS: 'can_sync_dtc_account_products',
  CAN_DELETE_DTC_PRODUCT: 'can_delete_dtc_product',

  CAN_VIEW_PRICE_SUMMARY: 'can_view_price_summary',
  CAN_VIEW_PRODUCT_PRICE_SUMMARY: 'can_view_product_price_summary',
  CAN_VIEW_PRICE_HISTORY: 'can_view_price_history',
  CAN_VIEW_PRODUCT_PRICE_HISTORY: 'can_view_product_price_history',
  CAN_VIEW_PRICE_ALERT: 'can_view_pricing_alert',
  CAN_UPDATE_PRICE_ALERT: 'can_update_pricing_alert',
  CAN_CREATE_PRICE_ALERT: 'can_create_pricing_alert',
  CAN_DELETE_PRICE_ALERT: 'can_delete_pricing_alert',

  CAN_VIEW_QUARANTINE: 'can_view_quarantine',
  CAN_CREATE_QUARANTINE: 'can_create_quarantine',
  CAN_LIFT_QUARANTINE: 'can_lift_quarantine',
} as const
